import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../utils/fetchers";
import { getAdminAccessToken } from "../../utils/auth";
import { Employee } from "../../types/modules/admin/employee.type";

interface UseParams {
  page?: number;
  limit?: number;
}

export const useEmployeesByAdmin = ({ page = 1, limit = 10 }: UseParams) => {
  const token = getAdminAccessToken();
  const queryParams = new URLSearchParams({
    page: page.toString(),
    limit: limit.toString(),
  });
  return useQuery({
    queryKey: ["employees-by-admin", page, limit],
    queryFn: () =>
      fetcher<{ data: Employee[]; total: number; totalPages: number }>(
        `admin?${queryParams.toString()}`,
        token
      ),
  });
};
